/**
 * Helpers de Visita concertada (captaciones).
 *
 * Política CRM:
 * - Precaptaciones / Contactados → ModalNuevaPrecaptacion
 * - Visita concertada (clic):
 *   · Cita aún no terminada (flujo CRM) → ModalNuevaPrecaptacion
 *   · Cita ya terminada O captación guardada desde móvil → ModalCompletarCamposAgente
 * - Nunca abrir la ficha de propiedad en edición al hacer clic en la tarjeta.
 */
export function parseCaptacionExtras(datosExtras) {
  if (!datosExtras) return {};
  if (typeof datosExtras === "object") return datosExtras;
  try {
    return JSON.parse(datosExtras || "{}");
  } catch {
    return {};
  }
}

export function captacionVieneDeMovilGuardada(item = {}) {
  const extras = parseCaptacionExtras(item.datos_extras);
  if (String(extras.origen_multimedia || "").toLowerCase() === "movil") return true;
  if (extras.progreso_movil === true || extras.progreso_movil === "true") return true;
  if (extras.progreso_guardado_at) return true;
  if (extras.captacion_exitosa === true || extras.captacion_exitosa === "true") return true;
  return false;
}

/** Fin efectivo de la cita activa (no cancelada) para decidir vencimiento. */
export function resolveCaptacionCitaFinIso(item = {}) {
  const fin = item.fecha_fin_cita || item.cita_fecha_fin || null;
  if (fin) return fin;
  return item.fecha_cita || item.cita_fecha_inicio || null;
}

export function captacionCitaYaTerminada(item = {}, nowMs = Date.now()) {
  const finIso = resolveCaptacionCitaFinIso(item);
  if (!finIso) return false;
  const t = new Date(finIso).getTime();
  if (Number.isNaN(t)) return false;
  return nowMs >= t;
}

/**
 * ¿Abrir ModalCompletarCamposAgente en Visita concertada?
 * - Móvil guardó progreso/captación → sí
 * - Cita de agenda ya terminada → sí
 * - Si no → ModalNuevaPrecaptacion
 */
export function shouldOpenCompletarCamposAgente(item = {}, nowMs = Date.now()) {
  if (captacionVieneDeMovilGuardada(item)) return true;
  if (captacionCitaYaTerminada(item, nowMs)) return true;
  return false;
}
